import { z } from 'zod';

export const ocaDynamicValuesSchema = z.object({
  initialApr: z.number().optional(),
  estimatedFinanceCharge: z.number().optional(),
  estimatedTotalPayments: z.number().optional(),
});
